"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Toast;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@synerg/react-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Toast(_ref) {
  var status = _ref.status,
    message = _ref.message,
    showToast = _ref.showToast,
    _ref$autoClose = _ref.autoClose,
    autoClose = _ref$autoClose === void 0 ? true : _ref$autoClose,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$autoCloseAfter = _ref.autoCloseAfter,
    autoCloseAfter = _ref$autoCloseAfter === void 0 ? 10000 : _ref$autoCloseAfter;
  return /*#__PURE__*/_react.default.createElement(_reactComponents.SdfAlert, {
    status: status,
    closeable: "true",
    toast: showToast,
    style: {
      display: "block !important"
    },
    autoClose: autoClose,
    autoCloseAfter: autoCloseAfter
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between w-full leading-xl"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, message)));
}